import { IS_GHOST_ACCOUNT, IS_MOBILE, IS_PROD_ENVIRONMENT } from '@/config/app.config';

const isDev = !IS_PROD_ENVIRONMENT;

const track = (eventName, params = {} as any) => {
  void eventName;
  void params;
  if (IS_GHOST_ACCOUNT || isDev) {
    return;
  }
};

const analyticsIdentify = async (account) => {
  void account;
  if (IS_GHOST_ACCOUNT || isDev) {
    return;
  }
};

const group = (appKey, params) => {
  void appKey;
  void params;
  if (IS_GHOST_ACCOUNT || isDev) {
    return;
  }
};

export { track, analyticsIdentify, group };
